import { useCallback } from "react";
import styles from "./style.module.css";
import { displayFile } from "utils/hooks/documentActions";
import { Button } from "antd";
import paperClip from "assets/icons/paper-clip.svg";
import bin from "assets/icons/bin.svg";

// a component that allows to display/remove file from upload
interface FileItemProps {
  file: any;
  removeFile: (file: any) => void;
}

export default function FileItem({ file, removeFile }: FileItemProps) {
  const onClickLink = useCallback(() => {
    displayFile(file);
  }, [file]);
  if (file.label) {
    return <div style={{ marginTop: 10 }}>{file.name}</div>;
  }
  return (
    <div className={styles.container}>
      <div className={styles["clip-and-name"]}>
        <img src={paperClip} alt="" />
        &nbsp;&nbsp;
        <a
          href="#"
          className={styles["doc-name"]}
          onClick={onClickLink}
          aria-label={`Display ${file.name}`}
        >
          {file.name}
        </a>
      </div>
      <Button
        type="link"
        className={styles["remove-btn"]}
        onClick={() => removeFile(file)}
        aria-label={`Remove ${file.name}`}
      >
        <img src={bin} alt="" />
      </Button>
    </div>
  );
}
